import { addMdFromUserAgent } from './actions';
export const initialAction = (watchContext) => {
    let userAgent = '';
    if (watchContext) {
        userAgent = watchContext.req.headers['user-agent'];
    }
    else if (typeof window !== 'undefined') {
        userAgent = window.navigator.userAgent;
    }
    return addMdFromUserAgent(userAgent);
};
